import StainDetailsForm from '../StainDetailsForm';
import styles from '../blocks.module.css';

/**
 * In-sheet stain details (no modal overlay). Changes apply to this slide only.
 */
export default function StainDetailsSubview({
    stain,
    onBack,
    onSave,
    readOnly = false,
    backLabel = '← Back',
    hideFooter = true,
    onDirtyChange = null,
    actionsRef = null,
}) {
    const name = stain?.name || stain?.abbreviation || 'Stain';

    return (
        <div className={styles.subview}>
            <div className={styles.subviewNav}>
                <button type="button" className={styles.linkButton} onClick={onBack}>
                    {backLabel}
                </button>
            </div>
            <h4 className={styles.subviewTitle}>{name}</h4>
            <p className={styles.jobText}>
                Applies to this slide only. Shared stain catalog changes belong in stain setup.
            </p>
            <StainDetailsForm
                stain={stain}
                open
                layout="embedded"
                hideChrome
                hideFooter={hideFooter}
                saveLabel="Save changes"
                onSave={onSave}
                onCancel={onBack}
                readOnly={readOnly}
                onDirtyChange={onDirtyChange}
                actionsRef={actionsRef}
            />
        </div>
    );
}
